export default "__VITE_ASSET__a7f49e59__"